var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBottom',_vm._g(_vm._b({attrs:{"icon":"","colorIcon":_vm.buttonIcons[_vm.name].color,"iconName":_vm.buttonIcons[_vm.name].icon}},'BaseBottom',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }